import { isEmpty } from 'lodash'
import { toValue, watch } from 'vue'
import { useStore } from 'vuex'

import LevelApiHandler from '@/api/level'
import { handleError } from '@/utils/error-handling'

/**
 * Loads levels for the given workspaces and stores them in `objectives/setAllWorkspacesLevels`.
 * Levels are reloaded every time the workspace ids source changes to a non-empty array.
 *
 * @param {import('vue').MaybeRefOrGetter<number[]>} workspaceIdsSource - Workspace ids (ref, getter or plain array).
 */
export const useWorkspacesLevels = (workspaceIdsSource = []) => {
  const store = useStore()

  const setLevelsByWorkspaces = async (workspaceIds = []) => {
    const levelApi = new LevelApiHandler()
    try {
      const levels = await levelApi.getLevelsForFilter({
        workspaceIds
      })

      await store.dispatch('objectives/setAllWorkspacesLevels', levels)
    } catch (error) {
      handleError({ error })
    }
  }

  watch(
    () => toValue(workspaceIdsSource),
    newValue => {
      if (newValue && Array.isArray(newValue) && !isEmpty(newValue)) {
        setLevelsByWorkspaces(newValue)
      }
    },
    { deep: true, immediate: true }
  )

  return {
    setLevelsByWorkspaces
  }
}
